module.exports = __webpack_public_path__ + "static/media/5DPO1.a4f0f1ed.jpg";